import React, { useState, useEffect, useMemo } from "react";
import Pagination from "../../hooks/Pagination";
import IrEmptyState from "./IrEmptyState";

// styles
import "./IrStyles.css";

// assets
import eLink from "../../assets/images/external-link.png";
import bgImg from "../../assets/images/1920x600-GRADIENT-BG.jpg";

let PageSize = 10;

const SecFilings = () => {
  const prodKey = process.env.REACT_APP_PRODUCT_KEY;
  const prUrl = process.env.REACT_APP_PUBLICRATES_URL;
  const url = `${prUrl}${prodKey}_sec_filing_items.json`;

  // states
  const [fetchedData, setFetchedData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);

  async function fetchData() {
    const response = await fetch(url);
    if (!response.ok) {
      const message = `An error has occured: ${response.status}`;
      // console.log(Error(message));
      // throw new Error(message);
    }
    const data = await response.json();
    // console.log(data.product);
    // Normalize `fitem` to always be an array
    const fitem = Array.isArray(data.product.fitem)
      ? data.product.fitem
      : data.product.fitem
      ? [data.product.fitem]
      : []; // If it's null/undefined, set it as an empty array
    setFetchedData(fitem);
    setCurrentPage(1);
  }

  useEffect(() => {
    fetchData();
  }, []);

  // const currentTableData = useMemo(() => {
  //   console.log(fetchedData);
  //   const firstPageIndex = (currentPage - 1) * PageSize;
  //   const lastPageIndex = firstPageIndex + PageSize;
  //   return fetchedData.slice(firstPageIndex, lastPageIndex);
  // }, [currentPage]);

  const currentTableData = useMemo(() => {
    if (!Array.isArray(fetchedData)) return [];
    const firstPageIndex = (currentPage - 1) * PageSize;
    const lastPageIndex = firstPageIndex + PageSize;
    return fetchedData.slice(firstPageIndex, lastPageIndex);
  }, [currentPage, fetchedData]);

  const [screenSize, getDimension] = useState({
    dynamicWidth: window.innerWidth,
    dynamicHeight: window.innerHeight,
  });

  const setDimension = () => {
    getDimension({
      dynamicWidth: window.innerWidth,
      dynamicHeight: window.innerHeight,
    });
  };

  useEffect(() => {
    window.addEventListener("resize", setDimension);

    return () => {
      window.removeEventListener("resize", setDimension);
    };
  }, [screenSize]);

  const hasEntries = Array.isArray(fetchedData)
    ? fetchedData.length > 0
    : Boolean(fetchedData);

  return (
    <section
      id="ir-sec-filings"
      className="bg-cover bg-center"
      style={{ backgroundImage: `url(${bgImg})` }}
    >
      {Array.isArray(fetchedData) ? (
        <div className="ir-sec-filings-main-container">
          {screenSize.dynamicWidth < 700 ? (
            <>
              <div
                className="ir-sec-filings-img-wrapper text-white"
                style={{ borderBottom: "1px solid white" }}
              >
                <div>
                  <h1 className="sub-header p-7 text-white">SEC Filings</h1>
                </div>
              </div>
              {!hasEntries ? (
                <IrEmptyState message="No SEC filings available at this time." />
              ) : (
                currentTableData.map((i, idx) => {
                  return (
                    <div
                      key={i.download_url || idx}
                      style={{
                        borderBottom: "1px solid white",
                      }}
                      className="text-white p-7"
                    >
                      <p className="m-0">{i.filing_date}</p>
                      <p className="m-0 fw-5">{i.item_name}</p>
                      <p className="m-0">Form {i.filing_type}</p>
                      <p>Supporing DD Documentation</p>
                      <a
                        href={i.download_url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="t-swifblue"
                      >
                        View
                      </a>
                    </div>
                  );
                })
              )}
            </>
          ) : (
            <div className="main-padding">
              <div className="main-margin">
                <h1 className="sub-header pb-8 mt-14 text-white">
                  SEC Filings
                </h1>
                <div class="main-margin table-shadow-main">
                  <div className="p-5 border border-black border-solid bg-white">
                    {!hasEntries ? (
                      <IrEmptyState message="No SEC filings available at this time." />
                    ) : (
                      <>
                        <table className="sec-table fixed-table w-full">
                          <thead>
                            <tr>
                              <th>Filing Date</th>
                              <th>Form</th>
                              <th c>Description</th>
                              <th>View</th>
                            </tr>
                          </thead>
                          <tbody>
                            {currentTableData.map((i, idx) => {
                              return (
                                <tr key={i.download_url || idx}>
                                  <td>{i.filing_date}</td>
                                  <td>{i.filing_type}</td>
                                  <td>{i.item_name}</td>
                                  <td>
                                    <a
                                      href={i.download_url}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      <img
                                        style={{ width: "25px" }}
                                        src={eLink}
                                        alt=""
                                      />
                                    </a>
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                        <Pagination
                          className="pagination-bar"
                          currentPage={currentPage}
                          totalCount={fetchedData.length}
                          pageSize={PageSize}
                          onPageChange={(page) => setCurrentPage(page)}
                        />
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      ) : (
        <div className="ir-sec-filings-main-container">
          {screenSize.dynamicWidth < 700 ? (
            <>
              <div
                className="ir-sec-filings-img-wrapper"
                style={{ borderBottom: "1px solid black" }}
              >
                <div>
                  <h1 className="sub-header px-7">SEC Filings</h1>
                </div>
              </div>
              <div
                style={{
                  padding: "30px 45px",
                  borderBottom: "1px solid black",
                }}
              >
                <p className="m-0">{fetchedData.filing_date}</p>
                <p className="m-0 fw-5">{fetchedData.item_name}</p>
                <p className="m-0">Form {fetchedData.filing_type}</p>
                <p>Supporing DD Documentation</p>
                <a
                  href={fetchedData.download_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="t-swifblue"
                >
                  View
                </a>
              </div>
            </>
          ) : (
            <div className="main-padding">
              <div className="main-margin">
                <h1 className="sub-header pb-8 mt-14">SEC Filings</h1>
                <div class="main-margin table-shadow-main">
                  <div className="p-5 border border-black border-solid">
                    {/* <div style={{ maxHeight: "500px", overflow: "scroll" }}> */}
                    {/* content */}
                    <table className="sec-table fixed-table w-full">
                      <tr style={{ borderBottom: "1px solid #ddd" }}>
                        <th>Filing Date</th>
                        <th>Form</th>
                        <th>Description</th>
                        <th>View</th>
                      </tr>
                      <tr>
                        <td>{fetchedData.filing_date}</td>
                        <td>{fetchedData.filing_type}</td>
                        <td>{fetchedData.item_name}</td>
                        <td>
                          <a
                            href={fetchedData.download_url}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img style={{ width: "25px" }} src={eLink} alt="" />
                          </a>
                        </td>
                      </tr>
                    </table>
                    <Pagination
                      className="pagination-bar"
                      currentPage={currentPage}
                      totalCount={fetchedData.length}
                      pageSize={PageSize}
                      onPageChange={(page) => setCurrentPage(page)}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </section>
  );
};

export default SecFilings;
